import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { getSocietyAdminData, getSocietySettings } from '../services/api';

/**
 * Renders children only when society setting reconciliation_enabled is "yes".
 * Otherwise redirects to society overview (deep links to ledger/reconcile etc. are blocked).
 */
const SocietyReconciliationGate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [state, setState] = useState<'loading' | 'allow' | 'deny'>('loading');

  useEffect(() => {
    const adminData = getSocietyAdminData();
    const sid = adminData?.societyId;
    if (!sid) {
      setState('deny');
      return;
    }
    let cancelled = false;
    getSocietySettings(sid)
      .then((res) => {
        if (cancelled) return;
        const ok = res.success && res.data && res.data.reconciliation_enabled === 'yes';
        setState(ok ? 'allow' : 'deny');
      })
      .catch(() => {
        if (!cancelled) setState('deny');
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (state === 'loading') {
    return (
      <div style={{ padding: '2rem', textAlign: 'center', color: '#64748b' }}>
        Loading…
      </div>
    );
  }
  if (state === 'deny') {
    return <Navigate to="/society/overview" replace />;
  }
  return <>{children}</>;
};

export default SocietyReconciliationGate;
